import { useQuery } from '@tanstack/react-query';
import { factoryGetInvitableOnsiteInterviewsKey } from '../factories/queries';
import { PermanentJobsService } from '../services';
import type { IGetInvitableOnsiteInterviewsPayload } from '../types';

interface IUseGetInvitableOnsiteInterviewsOptions {
  enabled?: boolean;
}

export const useGetInvitableOnsiteInterviews = (
  payload: IGetInvitableOnsiteInterviewsPayload,
  options?: IUseGetInvitableOnsiteInterviewsOptions,
) => {
  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: factoryGetInvitableOnsiteInterviewsKey(payload),
    queryFn: () => PermanentJobsService.getInvitableOnsiteInterviews(payload),
    enabled: options?.enabled ?? true,
    staleTime: 0,
  });

  return {
    data: data?.data || [],
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
